import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AppLayout from './layout/AppLayout';
import HomePage from './pricing-tool/features/homePage';
import CreatePricing from './pricing-tool/features/createPricing'
import VersionManagement from './pricing-tool/features/versionManagement'
import EditPricingDetails from './pricing-tool/features/editPricingDetails'
import LoginPage from './pricing-tool/features/loginPage'
import 'bootstrap/dist/css/bootstrap.min.css';
import ProtectedRoute from './components/ProtectedRoute';
import LoginRoute from './components/LoginRoute';
import { UserProvider } from './context/UserContext';
import { CurrencyProvider } from './context/CurrencyContext';
import HelpCenter from './pricing-tool/features/helpCenter';
import PricingTemplate from './pricing-tool/features/pricingTemplate';
import ErrorBoundary from './components/ErrorBoundary';
import ResourceRequest from './pricing-tool/features/resourceRequest';
import CreatePricingTemplate from './pricing-tool/features/createPricingTemplate';
import AuthErrorPage from './pricing-tool/features/AuthErrorPage';
import AdminPage from './components/AdminPage';
import ResourceRequestEntries from './pricing-tool/features/resourceRequestEntries';
import ResourceRecommendation from './pricing-tool/features/resourceRecommendation';
import SowApproverView from './pricing-tool/features/SowApproverView';
import SowNativeGuestReview from './pricing-tool/features/SowNativeGuestReview';

const SowStudio = React.lazy(() => import('./pricing-tool/sow-studio'));

function App() {
  return (
    <UserProvider>
      
      <Router>
        <Routes>
          {/* Public route for login page */}
          <Route path="/login" element={<LoginRoute><LoginPage /></LoginRoute>} />
          <Route path="/callback" element={<LoginRoute><LoginPage /></LoginRoute>} />
          <Route path="/auth-error" element={<LoginRoute><AuthErrorPage /></LoginRoute>} />
          <Route path="/sow-approval/:token" element={<SowApproverView />} />
          <Route path="/sow-native-guest" element={<SowNativeGuestReview />} />
          {/* Protected routes wrapped in AppLayout */}
          <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            {/* Redirect from "/" to "/home" */}
            <Route index element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<ProtectedRoute><ErrorBoundary><HomePage /></ErrorBoundary></ProtectedRoute>} />
            <Route path="/create-pricing" element={<ProtectedRoute><ErrorBoundary><CreatePricing /></ErrorBoundary></ProtectedRoute>} />
            <Route path="/create-pricing-template" element={<ProtectedRoute><ErrorBoundary><CreatePricingTemplate /></ErrorBoundary></ProtectedRoute>} />
            <Route path="/version-management" element={<CurrencyProvider><ProtectedRoute><ErrorBoundary><VersionManagement /></ErrorBoundary></ProtectedRoute></CurrencyProvider>} />
            <Route path="/edit-pricing-details" element={<CurrencyProvider><ProtectedRoute><ErrorBoundary><EditPricingDetails /></ErrorBoundary></ProtectedRoute></CurrencyProvider>} />
            <Route path="/help-center" element={<ProtectedRoute><ErrorBoundary><HelpCenter /></ErrorBoundary></ProtectedRoute>} />
            <Route path="/pricing-template" element={<CurrencyProvider><ProtectedRoute><ErrorBoundary><PricingTemplate /></ErrorBoundary></ProtectedRoute></CurrencyProvider>} />
            <Route path="/view-pricing-details" element={<CurrencyProvider><ProtectedRoute><ErrorBoundary><EditPricingDetails viewOnly={true} /></ErrorBoundary></ProtectedRoute></CurrencyProvider>} />
            <Route path="/resource-request" element={<ProtectedRoute><ErrorBoundary><ResourceRequestEntries /></ErrorBoundary></ProtectedRoute>} />
            <Route path="/resource-requests-overview" element={<ProtectedRoute><ErrorBoundary><ResourceRequest /></ErrorBoundary></ProtectedRoute>} />
            <Route
              path="/sow-studio"
              element={(
                <ProtectedRoute>
                  <ErrorBoundary>
                    <React.Suspense fallback={<div role="status">Loading SOW Studio…</div>}>
                      <SowStudio />
                    </React.Suspense>
                  </ErrorBoundary>
                </ProtectedRoute>
              )}
            />
            <Route path="/admin" element={<ProtectedRoute><ErrorBoundary><AdminPage /></ErrorBoundary></ProtectedRoute>} />
            <Route path="/recommendation-engine" element={<ProtectedRoute><ErrorBoundary><ResourceRecommendation /></ErrorBoundary></ProtectedRoute>} />
          </Route>
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
